"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = exports.darkColorsV2 = exports.lightColorsV2 = void 0;
var base = {
    // Reference these base colors in const colors
    black: '#000000',
    white: '#FFFFFF',
};
// To show colors in this file
// https://marketplace.visualstudio.com/items?itemName=kamikillerto.vscode-colorize
// "colorize.include": ["**/colors.ts"]
/** V2 Colors */
exports.lightColorsV2 = {
    bg01: 'white',
    bg02: '#F4F4F4',
    text01: '#000000',
    text02: '#171A20',
    text03: '#393C41',
    text04: '#5C5E62',
    text05: '#5D6876',
};
exports.darkColorsV2 = {
    bg01: '#2a2a2a',
    bg02: '#4a4a4a',
    text01: '#FFFFFF',
    text02: '#e8e5df',
    text03: '#c6c3be',
    text04: '#a3a19d',
    text05: '#a29789',
};
// COLOR NAMER
// https://colornamer.robertcooper.me
exports.colors = __assign(__assign(__assign({}, base), { primary: base.black, bronze: '#5E5753', coolGrey: '#58585c', warm: '#906d2b', 
    // Dark Mode Foundation: Only use these colors when in dark backgrounds or dark mode
    darkModeWarmGray: '#665c53', darkModeBronze: '#A1938C', darkModeCoolGrey: '#949599', darkModeWarm: '#D1C3A9', lightBackground: 'rgb(247, 247, 247)', loaderGray: 'rgba(0, 0, 0, 0.11)', lightGray: 'rgb(217, 217, 217)', magnesium: '#c2c2c2', placeholder: 'rgb(117, 117, 117)', disabledBackground: 'rgb(246, 246, 246)', modalBackdrop: 'rgba(0, 0, 0, 0.25)', pointedRock: '#646569', shadow: 'rgba(0, 0, 0, 0.2)', text: base.black, contrastText: base.white, warmGray: '#665c53', alert: '#AF150A', error: '#f44336', error2: 'rgba(155, 65, 65, 1)', darkGrey: '#757575', disabledLightGrey: '#AFAFAF', 
    // basic colors
    green: 'green', grey: 'grey', purple: 'purple', blue: 'blue', red: 'red', yellow: 'yellow', pink: 'pink', 
    /** new colors */
    riverStyx: '#171A20', riverStyx35: 'rgba(23, 26, 32, 0.35)', detectiveThriller: '#393C41', callisto: '#CCCFD3', glazedGranite: '#5C5E62', stretchLimo: '#2D2F34', amouretteEternelle: 'rgba(224, 223, 231)', white35: 'rgba(255, 255, 255, 0.35)', plaster: '#EAEAEA', brocade: '#8785C7' }), exports.lightColorsV2);
